import { useMemo } from "react";

import { Box } from "@mui/material";
import dynamic from "next/dynamic";

import { useFetchHeartsAnimation } from "./useFetchHeartsAnimation";

import { FormThermometer, FormThermometerProps } from "@/forms-design-system/FormThermometer/FormThermometer";
import { mergeSx } from "@/helpers/mergeSx";
const Lottie = dynamic(() => import("react-lottie"), { ssr: false });

type HeartsFormThermometerProps = Omit<FormThermometerProps, "backgroundContent"> & {
  animated?: boolean;
  animationKey?: string | number;
  loop?: boolean;
};

export const HeartsFormThermometer = ({
  animated = false,
  animationKey = 0,
  loop = false,
  sx,
  ...rest
}: HeartsFormThermometerProps) => {
  const heartsAnimationData = useFetchHeartsAnimation();
  const isCypressTest = !!window?.Cypress;

  const lottieOptions = useMemo(() => {
    return {
      animationData: heartsAnimationData,
      autoplay: true,
      loop,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };
  }, [heartsAnimationData, loop]);

  const heartsAnimation = (
    <>
      {animated && heartsAnimationData && !isCypressTest && (
        <Box
          key={`${animationKey}-${loop}`}
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            width: 140,
            height: 140,
            pointerEvents: "none",
          }}
        >
          <Lottie options={lottieOptions} width="100%" height="100%" isClickToPauseDisabled />
        </Box>
      )}
    </>
  );

  const styles = mergeSx(
    {
      position: "relative",
      overflow: "hidden",
    },
    sx
  );

  return <FormThermometer backgroundContent={heartsAnimation} sx={styles} {...rest} />;
};
